// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-transparent{
    background-color: transparent!important;
}
.videorolik {
    position: relative;
    display: flex;
    height: 500px;
    background-color: #f2f2f2;
    /* background-image: url(../../../../assets/bgVd.mp4); */
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 4px;
    overflow: hidden;
    padding: 40px 60px;
}
.videorolik--tarix{
    border-radius: 0!important;
}
.videorolik__link {
    position: absolute;
    top: -77px;
    left: -20px;
    display: block;
    padding: 90px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.3);
    opacity: .8;
    animation: pulse 1.8s linear infinite;
}
.videorolik__link:hover {
    opacity: 1;
}
.round1 {
    padding: 80px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.5);
    animation: pulse 1.8s linear infinite;
}
.round2 {
    padding: 60px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.9);
    animation: pulse 1.8s linear infinite;
}
.videorolik__title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 45px;
    color: #FFFFFF;
    margin-left: auto;
    z-index: 1;
}
.video-wrap {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /*display: none;*/
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .6);
    padding: 20px;
    z-index: 99;
}
.video-wrap__modal {
    max-width: 1000px;
    width: 100%;
    max-height: 500px;
}

.videoUnicon {
    transform: translate(-60px, -210px);
}
.videoUnicon--tarix {
    transform: translate(-60px, -130px);
}

@keyframes pulse {
    0% {
        transform: scale(.5);
        opacity: 0.6;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: scale(1.2);
        opacity: 0.6;
    }
}

@media screen and (max-width: 1451px){
    .videoUnicon {
        height: 100%;
        transform: translate(-60px, -40px);
    }
}

.animation{
    width: 300px;
    position: relative;
    animation: mymove 20s linear infinite;
}
@keyframes mymove {
    from {left: 0%;}
    to {left: 100%;}
}


/* button-Atrrangment */
.button-Atrrangment {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 20px;
    left: 190px !important;
}
.button-swiper {
    padding: 20px;
    background-color: #fff;
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.swiper-button-next,
.swiper-button-prev,
.swiper-pagination {
    top: unset !important;
    left: unset !important;
    right: unset !important;
    bottom: unset !important;
    width: auto !important;
    position: unset !important;
}
.swiper-button-prev::after,
.swiper-button-next::after {
    color: #0E0E4B;
    font-size: 24px !important;
}
.swiper-pagination-bullet-active,
.swiper-pagination-bullet {
    width: 12px !important;
    height: 12px !important;
    background-color: #0E0E4B !important;
}

#edit-share-btn {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.25rem;
    background-color: #fff;
    cursor: pointer;
    border: 2px solid #56b8f5;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    display: none;
    align-items: center;
    justify-content: center;
    transition: color 0.2s, background-color .2s ease-in-out;
}
#edit-share-btn:hover {
    background-color: #56b8f5;
}
#edit-share-btn:hover svg path {
    fill: #fff;
}
#edit-share-btn svg {
    pointer-events: none;
}
.btnEntrance {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: btnEntrance;
}
@keyframes btnEntrance {
    0% {
        opacity: 0;
        transform: scale3d(.3, .3, .3);
    }
    100% {
        opacity: 1;
    }
}



@media screen and (max-width: 1690px) {
    .nav_link {
        font-size: .8rem !important;
        padding: 10px;
    }
}
@media screen and (max-width: 1401px) {
    .nav_link {
        /* font-size: .6rem !important; */
        padding: 5px !important;
    }
}

@media screen and (max-width: 1200px) {
    .container {
        padding-left: 4rem;
        padding-right: 4rem;
    }
    .desktop {
        display: none;
    }
    .mobile {
        display: block;
    }
    .menus {
        flex-direction: column;
    }
    .hamBox {
        width: 30px;
        height: 30px;
        padding: 2.4rem 0;
    }
    .dropdown {
        top: 90%;
        /* left: 0;
        right: 0; */
        min-width: 80%;
    }
}

@media screen and (max-width: 768px) {
    .news .swiper-slide,
    .products .swiper-slide,
    .news_details .swiper-slide {
        width: 48%;
    }
    .servis-card {
        width: 100%!important;
    }
}

@media screen and (max-width: 867px){
    .container {
        padding-left: 2rem;
        padding-right: 2rem;
    }
    
    .c-col{
        width: 100% !important;
    }
}

@media screen and (max-width: 640px) {
    .container {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .card {
        width: 100% !important;
    }
    .trim {
        width: 100% !important;
    }
    .card_footer {
        width: 100% !important;
    }
    .products {
        width: 100% !important;
    }
}

@media screen and (max-width: 425px) {
    body #ym-informer {
        left: 0 !important;
        width: 425px !important;
    }
    footer .box-child {
        width: 100% !important;
    }
    .news .swiper-slide,
    .products .swiper-slide,
    .news_details .swiper-slide {
        width: 100%;
    }
    .preloader .text {
        left: calc(50% + 350px);
    }
    .common_title {
        font-size: 16px !important;
        line-height: 1rem !important;
    }
    .fotos {
        width: 100% !important;
    }
    .products {
        width: 100% !important;
    }
    .news .products {
        width: 100% !important;
    }
    /*.dropdown {*/
    /*    top: 90% !important;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    min-width: 80%;*/
    /*}*/
    .dropdown .menu-items {
        font-size: 15px;
    }
    .products .swiper-pagination-bullet:nth-child(even) {
        display: none;
    }
    .language {
        right: 2.5rem !important;
    }
}

@media screen and (max-width: 375px) {
    body #ym-informer {
        left: 0 !important;
        width: 375px !important;
    }
    .left_nav {
        width: 85% !important;
    }
}

.transparent {
    background: transparent;
}

.partners .swiper-button-prev,
.partners .swiper-button-next,
.products .swiper-button-prev,
.products .swiper-button-next {
    display: none;
}

.products .swiper-pagination {
    bottom: -5px !important;
}

.partners .mySwiper {
    overflow: initial;
    padding-top: 40px !important;
    padding-bottom: 40px !important;
}

.products .mySwiper {
    overflow: hidden;
    padding-bottom: 20px !important;
}
.input:focus-visible {
    outline: none !important;
    border: none !important;
}

/* .contact {
    background: url("./assets/map-1.png") no-repeat center / cover;
} */

.products .swiper,
.news .swiper {
    padding: 30px 0 !important;
}

/* *::selection {
    display: none;
} */

.news_details .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
}

.news_details .swiper-slide {
    background-position: center;
    background-size: cover;
}

.news_details .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
}

.partners .img:last-child {
    margin-right: 50px;
}

.partners .img_reverse:first-child {
    margin-left: 70px;
}

::-webkit-scrollbar {
    width: 15px;
    border-radius: 50px !important;
}

::-webkit-scrollbar-thumb{
    border: 3px solid transparent;
    border-radius: 9px;
    background-clip: content-box;
    background-color: #fff;
}
::-webkit-scrollbar-track{
    background-color: #0E0E4B;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/index.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,wDAAwD;IACxD,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,WAAW;IACX,qCAAqC;AACzC;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;AACzC;AACA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,aAAa;IACb,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,oBAAoB;QACpB,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kCAAkC;IACtC;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI,MAAM,QAAQ,CAAC;IACf,IAAI,UAAU,CAAC;AACnB;;;AAGA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;;IAGI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;;IAEI,cAAc;IACd,0BAA0B;AAC9B;AACA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wDAAwD;AAC5D;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI;QACI,UAAU;QACV,8BAA8B;IAClC;IACA;QACI,UAAU;IACd;AACJ;;;;AAIA;IACI;QACI,2BAA2B;QAC3B,aAAa;IACjB;AACJ;AACA;IACI;QACI,iCAAiC;QACjC,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,QAAQ;QACR;mBACW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI;;;QAGI,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;;;QAGI,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,IAAI;IACJ;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;;IAEI,0BAA0B;AAC9B;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[".bg-transparent{\n    background-color: transparent!important;\n}\n.videorolik {\n    position: relative;\n    display: flex;\n    height: 500px;\n    background-color: #f2f2f2;\n    /* background-image: url(../../../../assets/bgVd.mp4); */\n    background-size: cover;\n    background-position: center center;\n    background-repeat: no-repeat;\n    border-radius: 4px;\n    overflow: hidden;\n    padding: 40px 60px;\n}\n.videorolik--tarix{\n    border-radius: 0!important;\n}\n.videorolik__link {\n    position: absolute;\n    top: -77px;\n    left: -20px;\n    display: block;\n    padding: 90px;\n    border-radius: 50%;\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    opacity: .8;\n    animation: pulse 1.8s linear infinite;\n}\n.videorolik__link:hover {\n    opacity: 1;\n}\n.round1 {\n    padding: 80px;\n    border-radius: 50%;\n    border: 3px solid rgba(255, 255, 255, 0.5);\n    animation: pulse 1.8s linear infinite;\n}\n.round2 {\n    padding: 60px;\n    border-radius: 50%;\n    border: 3px solid rgba(255, 255, 255, 0.9);\n    animation: pulse 1.8s linear infinite;\n}\n.videorolik__title {\n    font-family: 'Montserrat', sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 36px;\n    line-height: 45px;\n    color: #FFFFFF;\n    margin-left: auto;\n    z-index: 1;\n}\n.video-wrap {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    /*display: none;*/\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, .6);\n    padding: 20px;\n    z-index: 99;\n}\n.video-wrap__modal {\n    max-width: 1000px;\n    width: 100%;\n    max-height: 500px;\n}\n\n.videoUnicon {\n    transform: translate(-60px, -210px);\n}\n.videoUnicon--tarix {\n    transform: translate(-60px, -130px);\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(.5);\n        opacity: 0.6;\n    }\n    50% {\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1.2);\n        opacity: 0.6;\n    }\n}\n\n@media screen and (max-width: 1451px){\n    .videoUnicon {\n        height: 100%;\n        transform: translate(-60px, -40px);\n    }\n}\n\n.animation{\n    width: 300px;\n    position: relative;\n    animation: mymove 20s linear infinite;\n}\n@keyframes mymove {\n    from {left: 0%;}\n    to {left: 100%;}\n}\n\n\n/* button-Atrrangment */\n.button-Atrrangment {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    bottom: 20px;\n    left: 190px !important;\n}\n.button-swiper {\n    padding: 20px;\n    background-color: #fff;\n    width: 180px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.swiper-button-next,\n.swiper-button-prev,\n.swiper-pagination {\n    top: unset !important;\n    left: unset !important;\n    right: unset !important;\n    bottom: unset !important;\n    width: auto !important;\n    position: unset !important;\n}\n.swiper-button-prev::after,\n.swiper-button-next::after {\n    color: #0E0E4B;\n    font-size: 24px !important;\n}\n.swiper-pagination-bullet-active,\n.swiper-pagination-bullet {\n    width: 12px !important;\n    height: 12px !important;\n    background-color: #0E0E4B !important;\n}\n\n#edit-share-btn {\n    width: 2.5rem;\n    height: 2.5rem;\n    font-size: 1.25rem;\n    background-color: #fff;\n    cursor: pointer;\n    border: 2px solid #56b8f5;\n    border-radius: 50%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 99;\n    display: none;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s, background-color .2s ease-in-out;\n}\n#edit-share-btn:hover {\n    background-color: #56b8f5;\n}\n#edit-share-btn:hover svg path {\n    fill: #fff;\n}\n#edit-share-btn svg {\n    pointer-events: none;\n}\n.btnEntrance {\n    animation-duration: .2s;\n    animation-fill-mode: both;\n    animation-name: btnEntrance;\n}\n@keyframes btnEntrance {\n    0% {\n        opacity: 0;\n        transform: scale3d(.3, .3, .3);\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n\n\n@media screen and (max-width: 1690px) {\n    .nav_link {\n        font-size: .8rem !important;\n        padding: 10px;\n    }\n}\n@media screen and (max-width: 1401px) {\n    .nav_link {\n        /* font-size: .6rem !important; */\n        padding: 5px !important;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .container {\n        padding-left: 4rem;\n        padding-right: 4rem;\n    }\n    .desktop {\n        display: none;\n    }\n    .mobile {\n        display: block;\n    }\n    .menus {\n        flex-direction: column;\n    }\n    .hamBox {\n        width: 30px;\n        height: 30px;\n        padding: 2.4rem 0;\n    }\n    .dropdown {\n        top: 90%;\n        /* left: 0;\n        right: 0; */\n        min-width: 80%;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .news .swiper-slide,\n    .products .swiper-slide,\n    .news_details .swiper-slide {\n        width: 48%;\n    }\n    .servis-card {\n        width: 100%!important;\n    }\n}\n\n@media screen and (max-width: 867px){\n    .container {\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n    \n    .c-col{\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 640px) {\n    .container {\n        padding-left: 1rem;\n        padding-right: 1rem;\n    }\n    .card {\n        width: 100% !important;\n    }\n    .trim {\n        width: 100% !important;\n    }\n    .card_footer {\n        width: 100% !important;\n    }\n    .products {\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    body #ym-informer {\n        left: 0 !important;\n        width: 425px !important;\n    }\n    footer .box-child {\n        width: 100% !important;\n    }\n    .news .swiper-slide,\n    .products .swiper-slide,\n    .news_details .swiper-slide {\n        width: 100%;\n    }\n    .preloader .text {\n        left: calc(50% + 350px);\n    }\n    .common_title {\n        font-size: 16px !important;\n        line-height: 1rem !important;\n    }\n    .fotos {\n        width: 100% !important;\n    }\n    .products {\n        width: 100% !important;\n    }\n    .news .products {\n        width: 100% !important;\n    }\n    /*.dropdown {*/\n    /*    top: 90% !important;*/\n    /*    left: 0;*/\n    /*    right: 0;*/\n    /*    min-width: 80%;*/\n    /*}*/\n    .dropdown .menu-items {\n        font-size: 15px;\n    }\n    .products .swiper-pagination-bullet:nth-child(even) {\n        display: none;\n    }\n    .language {\n        right: 2.5rem !important;\n    }\n}\n\n@media screen and (max-width: 375px) {\n    body #ym-informer {\n        left: 0 !important;\n        width: 375px !important;\n    }\n    .left_nav {\n        width: 85% !important;\n    }\n}\n\n.transparent {\n    background: transparent;\n}\n\n.partners .swiper-button-prev,\n.partners .swiper-button-next,\n.products .swiper-button-prev,\n.products .swiper-button-next {\n    display: none;\n}\n\n.products .swiper-pagination {\n    bottom: -5px !important;\n}\n\n.partners .mySwiper {\n    overflow: initial;\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n}\n\n.products .mySwiper {\n    overflow: hidden;\n    padding-bottom: 20px !important;\n}\n.input:focus-visible {\n    outline: none !important;\n    border: none !important;\n}\n\n/* .contact {\n    background: url(\"./assets/map-1.png\") no-repeat center / cover;\n} */\n\n.products .swiper,\n.news .swiper {\n    padding: 30px 0 !important;\n}\n\n/* *::selection {\n    display: none;\n} */\n\n.news_details .swiper {\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 50px;\n}\n\n.news_details .swiper-slide {\n    background-position: center;\n    background-size: cover;\n}\n\n.news_details .swiper-slide img {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.partners .img:last-child {\n    margin-right: 50px;\n}\n\n.partners .img_reverse:first-child {\n    margin-left: 70px;\n}\n\n::-webkit-scrollbar {\n    width: 15px;\n    border-radius: 50px !important;\n}\n\n::-webkit-scrollbar-thumb{\n    border: 3px solid transparent;\n    border-radius: 9px;\n    background-clip: content-box;\n    background-color: #fff;\n}\n::-webkit-scrollbar-track{\n    background-color: #0E0E4B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
